import axios from 'axios'

const CART = `/functions/cart_total.php`

const changeCountryTop = document.getElementById('cart-shipping-country-top')
const changeCountryBottom = document.getElementById('cart-shipping-country-bottom')
const shippingFormTop = document.getElementById('cart-shipping-form-top')
const shippingFormBottom = document.getElementById('cart-shipping-form-bottom')
const inputCode = document.querySelector('.j-cart-discount-code__input')
const buttonCode = document.querySelector('.j-cart-discount-code__btn')
const updateQntSelect = document.querySelectorAll('.j-cart-qty')
const goToCheckoutBtn = document.querySelectorAll('.j-cart-btn-gotocheckout')

const updateShipping = (element) => {
	
	element.target.classList.remove('error')
	
	if(element.target.id == 'cart-shipping-country-top'){
		shippingFormTop.submit()
	}
	if(element.target.id == 'cart-shipping-country-bottom'){
		shippingFormBottom.submit()
	}
	
	setTimeout(function() {
		location.reload()
	}, 200)
	
}

const init = (selector) => {
	selector.addEventListener('change', updateShipping)
}

if(changeCountryTop){
	init(changeCountryTop)
}

if(changeCountryBottom){
	init(changeCountryBottom)
}

const updateQuantity = (event) => {
	const cartForm = document.querySelector('.j-cart-body-main')
	cartForm.requestSubmit()
	
	setTimeout(function() {
		location.reload()
	}, 200)
}

if(updateQntSelect){
	updateQntSelect.forEach(item => {
		item.addEventListener('change', updateQuantity)
	})	
}

async function checkCode (item) {
	
	buttonCode.disabled = true
	
	const loader = document.querySelector('.j-cart-discount-loader')
	const checkoutArea = document.querySelectorAll('.j-cart-checkout-box-totals')
	
	item.target.disabled = true
	
	if(loader) {
		loader.classList.add('is-active')
		inputCode.classList.add('is-hidden')
	}
/* 	let type = item.target.dataset.area
	const loader = document.getElementById('search-area-loader-' + type)
	
	
	if(loader){
		loader.classList.add('is-active')
	}
	
	let param = item.target.value
	let update = item.target.dataset.sync
	const brandOn = document.getElementById('road-brand')
	const brandOff = document.getElementById('offroad-brand') */
	
	const msgBox = document.querySelector('.j-cart-discount-msg')
	
	axios.get(CART, {
		params: {
			lang: window.motostorm.lang,
			code: inputCode.value
		},
	})
	.then(resp => {
		checkoutArea.forEach(item => {
			item.innerHTML = resp.data.html
		})

		if(loader){
			loader.classList.remove('is-active')
		}
		msgBox.classList.add(resp.data.response)
		if(resp.data.refresh === true){
			//location.reload()
			window.location.replace(window.location.href)
		}
		msgBox.innerHTML = resp.data.msg
		setTimeout(function() {
		  //your code to be executed after 1 second
		  msgBox.classList.remove(resp.data.response)
		  inputCode.value = ''
		  inputCode.classList.remove('is-hidden')
		}, 2000);

	})
	.catch(err => {
		// Handle Error Here
		console.error(err);
	})
}

const goToCheckout = (event) => {

	var checkoutUrl = event.target.dataset.url
	history.pushState({}, '', checkoutUrl )
	location.href = checkoutUrl
	
}

if(inputCode){
	["change", "keyup", "paste", "input", "propertychange"].forEach(function(event) {
	inputCode.addEventListener(event, () => {
		buttonCode.disabled = false
		buttonCode.addEventListener('click', checkCode)
	})
	})
}

if( goToCheckoutBtn ){
	goToCheckoutBtn.forEach(item => {
		item.addEventListener('click', goToCheckout)
	})
}